// extracted by mini-css-extract-plugin
module.exports = {"menuToggleButton":"navigation-module--menu-toggle-button--3g11L","isOpen":"navigation-module--is-open--2Vp3l"};